module.exports = __webpack_public_path__ + "static/media/move.e49f23b6.svg";